export default [
	{
		name: 'preViewLandingPage',
		method: 'POST',
		desc: '落地页数据',
		path: '/api/insurance/urlTransService/sogouUploadConvertData'
	},
	{
	    name: 'generateScheme',
	    method: 'POST',
	    desc: '获取小程序scheme地址',
	    path: '/api/insurance/urlTransService/generateScheme'
	}
];
